import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { setEditorZoom, setEditorAutoZoom } from '../../actions';
import ZoomInIcon from 'material-ui/svg-icons/action/zoom-in';
import ZoomOutIcon from 'material-ui/svg-icons/action/zoom-out';
// import IconAddToFav from 'material-ui/svg-icons/action/favorite';

import { IconButton, Toggle } from 'material-ui';

const styles = {
    smallIcon: {
        width: 20,
        height: 20,
    },
    small: {
        width: 32,
        height: 32,
        padding: 2,
    },
};
const ZoomControls = ({ zoom, autozoom, setEditorZoom, style, setEditorAutoZoom }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', ...style }}>
            <IconButton
                iconStyle={styles.smallIcon}
                style={styles.small}
                onClick={() => {
                    setEditorZoom(zoom - 0.1, false);
                }}
            >
                <ZoomOutIcon />
            </IconButton>
            <span style={{ fontSize: 12, display: 'inline-block', minWidth: 30, textAlign: 'center' }}>
                {parseInt(zoom * 100) + '%'}
            </span>
            <IconButton
                iconStyle={styles.smallIcon}
                style={styles.small}
                onClick={() => {
                    setEditorZoom(zoom + 0.1, false);
                }}
            >
                <ZoomInIcon />
            </IconButton>
            {/* <Toggle
                style={{ width: 150 }}
                label="autozoom"
                defaultToggled={autozoom}
                onToggle={(e, zoom) => {
                    setEditorAutoZoom(zoom);
                }}
            /> */}
        </div>
    );
};

const mapStateToProps = ({ editor }) => {
    return {
        zoom: editor.zoom,
        autozoom: editor.autozoom,
    };
};
const mapDispatchToProps = { setEditorZoom, setEditorAutoZoom };

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    lifecycle({
        componentWillReceiveProps() {},
        componentDidMount() {},
    }),
)(ZoomControls);



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/controls/ZoomControls.js
 **/